import { dateUStoISO } from '../date-converter';

/**
 * Parse dates from Arcimedes list API (ISO yyyy-mm-dd, US mm/dd/yyyy, timestamps).
 */
export function parseArcimedesDate(val) {
    if (val == null || val === '' || String(val).trim().toUpperCase() === 'MTM') return null;
    if (val instanceof Date) {
        return isNaN(val.getTime()) ? null : val;
    }
    const s = String(val).trim();
    if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
        const d = new Date(s.length <= 10 ? `${s}T12:00:00` : s);
        return isNaN(d.getTime()) ? null : d;
    }
    const isoFromUs = dateUStoISO(s);
    if (isoFromUs) {
        const d = new Date(`${isoFromUs}T12:00:00`);
        return isNaN(d.getTime()) ? null : d;
    }
    const d = new Date(s);
    return isNaN(d.getTime()) ? null : d;
}

function parseOriginalLeaseTermYears(term) {
    if (term == null || term === '') return NaN;
    const n = Number(String(term).replace(/[^\d.]/g, ''));
    return n === n && n > 0 ? n : NaN;
}

function addTermYearsToDate(base, termYears) {
    const derived = new Date(base.getTime());
    derived.setFullYear(derived.getFullYear() + Math.floor(termYears));
    const frac = termYears - Math.floor(termYears);
    if (frac > 0) {
        derived.setMonth(derived.getMonth() + Math.round(frac * 12));
    }
    return derived;
}

/**
 * Prefer PROPERTY lease expiration; if missing/unparsable, derive from commencement + original term
 * (UNDERWRITING_SINGLE_TENANT.ORIGINAL_LEASE_TERM on V7), same idea as PropertyInfo when expiration is blank.
 * Sale-lease-back: close of escrow + original term when expiration is still blank (PropertyInfo auto-fill path).
 */
export function effectiveLeaseExpirationDate(el) {
    let exp = parseArcimedesDate(el.LEASE_EXPIRATION_DATE);
    if (exp) {
        return exp;
    }
    const termYears = parseOriginalLeaseTermYears(el.ORIGINAL_LEASE_TERM);
    if (!termYears) {
        return null;
    }
    const comm = parseArcimedesDate(el.LEASE_COMMENCEMENT_DATE);
    if (comm) {
        return addTermYearsToDate(comm, termYears);
    }
    if (el.SALE_LEASE_BACK === 'Yes') {
        const coe = parseArcimedesDate(el.CLOSE_OF_ESCROW);
        if (coe) {
            return addTermYearsToDate(coe, termYears);
        }
    }
    return null;
}
